import { render, staticRenderFns } from "./timer.vue?vue&type=template&id=564e0333&"
import script from "./timer.vue?vue&type=script&lang=js&"
export * from "./timer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports